import intl from 'react-intl-universal';
import zhCN from '@src/locales/build/zh_CN.json';
import enUS from '@src/locales/build/en_US.json';
import koKR from '@src/locales/build/ko_KR.json';
import jaJP from '@src/locales/build/ja_JP.json';
import zhHK from '@src/locales/build/zh_HK.json';
import thTH from '@src/locales/build/th_TH.json';
import itIT from '@src/locales/build/it_IT.json';
import esES from '@src/locales/build/es_ES.json';
import frFR from '@src/locales/build/fr_FR.json';
import idID from '@src/locales/build/id_ID.json';
import ruRU from '@src/locales/build/ru_RU.json';
import deDE from '@src/locales/build/de_DE.json';
import ptPT from '@src/locales/build/pt_PT.json';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

export const LOCALE_DATA = {
  en: enUS,
  'zh-cn': zhCN,
  'zh-tc': zhHK,
  ko: koKR,
  ja: jaJP,
  th: thTH,
  it: itIT,
  id: idID,
  es: esES,
  ru: ruRU,
  de: deDE,
  fr: frFR,
  'zh-Hant': zhHK,
  'zh-Hans': zhCN,
  in: idID,
  pt: ptPT
  //"zh-TW": zhTW,
  //"fr-FR": frFr,
  //"ja-JP": jaJP,
};
export const CURRENT_LOCALE = '';
export default async function localesInit(language) {
  const lang = language || getLanguageByPath();
  //
  window.intl = intl;
  await intl.init({
    currentLocale: lang,
    locales: LOCALE_DATA
  });
}
